module.exports = __webpack_public_path__ + "static/faststarter_2017-b976acd5a3a1e880205c176a41737562.svg";